import { DataGrid, Toastr, defaultNotifyOptions } from "@serenity-is/corelib";

defaultNotifyOptions.positionClass = 'toast-top-full-width';
defaultNotifyOptions.timeOut = 8000;
defaultNotifyOptions.extendedTimeOut = 4000;

